// extracted by mini-css-extract-plugin
module.exports = {"errorWrapper":"error_errorWrapper__bTKfV"};